import * as Yup from 'yup';
import { validatePhone } from 'react-international-phone';

import { VALIDATIONS_ERROR } from '~constants/index';

export function validPhone(
  this: Yup.StringSchema,
  message = VALIDATIONS_ERROR.PHONE,
): Yup.StringSchema {
  return this.test('valid-phone', message, (value) => {
    if (value) {
      const { isValid } = validatePhone(value);

      return isValid;
    }

    return false;
  });
}

const MIN_LENGTH_PASSWORD = 6;

export function validPassword(this: Yup.StringSchema): Yup.StringSchema {
  return this.min(
    MIN_LENGTH_PASSWORD,
    VALIDATIONS_ERROR.MIN_LENGTH(MIN_LENGTH_PASSWORD),
  ).required(VALIDATIONS_ERROR.REQUIRED);
}

export function validConfirmPassword(
  this: Yup.StringSchema,
  passwordFieldKey: string,
): Yup.StringSchema {
  return this.oneOf(
    [Yup.ref(passwordFieldKey), null],
    VALIDATIONS_ERROR.PASSWORD_NOT_MATCH,
  ).required(VALIDATIONS_ERROR.REQUIRED);
}
